import React from "react";
import { Navigate } from "react-router-dom";

// 경로 변경: boards/Boards, boards/BoardMasters
import Boards from "./boards/Boards";            // 게시물 생성관리
import BoardMasters from "./boards/BoardMasters"; // 게시판생성관리
import PopupMgr from "./pages/PopupMgr";
import Usage from "./pages/Usage";
import Login from "./pages/Login";

export const cmsRoutes = [
  { path: "login", element: <Login /> },

  // 기본 진입 → 게시물 관리로
  { path: "", element: <Navigate to="login" replace /> },

  // 게시판관리 (좌측 드롭다운 두 항목)
  { path: "boards/post",   element: <Boards /> },
  { path: "boards/master", element: <BoardMasters /> },
  // /cms/boards 로 접근하면 /post 로 정규화
  { path: "boards", element: <Navigate to="boards/master" replace /> },

  // 나머지 메뉴
  { path: "popups", element: <PopupMgr /> },

  // ✅ 통계관리
  { path: "usage",  element: <Usage /> },
];
